import React from 'react';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import InternalSupportWidget from 'components/InternalSupportWidget';

const useInternalSupportWidget = ({ containerClassName }) => {
  const clientDetails = useSelector(makeSelectClientDetails());
  const clientMetadata = _get(clientDetails, 'metadata');
  const showInternalSupportWidget = _get(clientMetadata, 'showInternalSupport');

  const renderInternalSupportWidget = () => {
    if (!showInternalSupportWidget) return null;

    return <InternalSupportWidget containerClassName={containerClassName} />;
  };

  return { showInternalSupportWidget, renderInternalSupportWidget };
};

export default useInternalSupportWidget;
